/**
 * ?preview= screens are for local development screenshots.
 * A production build never mounts them. The native app is served from
 * localhost, so a localhost hostname is not a development build.
 * CommonJS only. No object spread.
 */

function queryPreviewAllowed(nodeEnv, isNative) {
  return nodeEnv === 'development' && isNative !== true;
}

module.exports = {
  queryPreviewAllowed,
};
